import { TimepointExamReassignmentPreviewResponse, TimepointSubmissionStatus } from '@common/config/api/client'
import { Paper, Table, TableContainer, Typography, useTheme } from '@mui/material'
import ReassignExamTimepointTableHeader from './ReassignExamTimepointTableHeader'
import ReassignExamTimepointTableBody from './ReassignExamTimepointTableBody'
import { Fragment } from 'react/jsx-runtime'

export default function ReassignExamTimepointTable({
  timepoint,
  timepointStatus,
}: {
  timepoint: TimepointExamReassignmentPreviewResponse
  timepointStatus: TimepointSubmissionStatus | ''
}) {
  const theme = useTheme()

  return (
    <Fragment>
      <Typography color="text.primary" variant="subtitle1">
        Submission status
      </Typography>
      <Paper
        sx={{
          borderRadius: 2,
          border: `1px solid ${theme.palette.secondary.main}`,
          overflowY: 'auto',
        }}
      >
        <TableContainer>
          <Table size="small">
            <ReassignExamTimepointTableHeader />
            <ReassignExamTimepointTableBody timepoint={timepoint} timepointStatus={timepointStatus} />
          </Table>
        </TableContainer>
      </Paper>
    </Fragment>
  )
}
